import { Component, OnInit, Input, EventEmitter, Output } from "@angular/core";
import { Router } from "@angular/router";
import { ModalController } from "@ionic/angular";

@Component({
    selector: "app-modal-component",
    templateUrl: "./modal-default..html",
    styleUrls: ["./modal-default.component.scss"],
    standalone: false
})
export class ModalDefaultComponent implements OnInit {

  @Output() stateOpen = new EventEmitter<boolean>();
  @Input() enabledClose = true;

  constructor(
    public modal: ModalController,
    private route: Router
  ) { }

  ngOnInit() { }

  async close() {

    this.stateOpen.emit(false);

    this.route.routeReuseStrategy.shouldReuseRoute = () => false;
    await this.route.navigate([this.route.url]);
  }

}
